// extracted by mini-css-extract-plugin
module.exports = {"label":"GroupMembersList_label__3dcuI"};